(() => {
  if (customElements.get('ergosed-photo-spin')) return;
  customElements.define('ergosed-photo-spin', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.jumpTarget = this.closest('.erg-photo-spin-section');
      this.installJump = () => {
        const main = document.getElementById('MainContent');
        const wrapper = main?.querySelector('.product-details > .group-block');
        if (!wrapper || wrapper.querySelector('.erg-mobile-spin-jump')) return;
        const link = document.createElement('a');
        link.className = 'erg-mobile-spin-jump';
        link.href = '#' + this.jumpTarget.id;
        link.textContent = this.dataset.jumpLabel;
        link.setAttribute('aria-label', this.jumpTarget.querySelector('h2').textContent);
        link.addEventListener('click', event => {
          event.preventDefault();
          this.jumpTarget.scrollIntoView({
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
            block: 'start'
          });
        });
        wrapper.prepend(link);
        this.jumpLink = link;
      };
      this.installJump();
      const main = document.getElementById('MainContent');
      if (main) {
        this.jumpObserver = new MutationObserver(this.installJump);
        this.jumpObserver.observe(main, { childList:true, subtree:true });
      }
      this.frame = 0;
      this.meta = JSON.parse(this.querySelector('[data-spin-frames]').textContent);
      this.stage = this.querySelector('[data-spin-stage]');
      this.sheet = this.querySelector('[data-spin-sheet]');
      this.poster = this.querySelector('[data-spin-poster]');
      this.open = this.querySelector('[data-spin-open]');
      this.status = this.querySelector('[data-spin-status]');
      this.open.addEventListener('click', () => this.load());
      this.ro = new ResizeObserver(() => { if (this.ready) this.draw(this.frame); });
      this.ro.observe(this.stage);
      this.open.disabled = false;
      this.status.textContent = this.dataset.start;
      this.stage.addEventListener('keydown', e => {
        if (!['ArrowLeft','ArrowRight'].includes(e.key)) return;
        e.preventDefault();
        if (!this.ready) { this.load(); return; }
        this.draw(this.frame + (e.key === 'ArrowRight' ? 1 : -1));
      });
      this.stage.addEventListener('pointerdown', e => {
        if (!this.ready || !e.isPrimary) return;
        this.drag = { x:e.clientX, frame:this.frame, id:e.pointerId };
        this.stage.setPointerCapture(e.pointerId);
        this.stage.classList.add('is-dragging');
      });
      this.stage.addEventListener('pointermove', e => {
        if (!this.drag || this.drag.id !== e.pointerId) return;
        this.draw(this.drag.frame + Math.round((e.clientX-this.drag.x)/32));
      });
      ['pointerup','pointercancel','lostpointercapture'].forEach(name => this.stage.addEventListener(name, () => { this.drag = null; this.stage.classList.remove('is-dragging'); }));
    }
    disconnectedCallback() { this.ro?.disconnect(); this.jumpObserver?.disconnect(); this.jumpLink?.remove(); }
    async load() {
      if (this.loading || this.ready) return;
      this.loading = true;
      this.open.disabled = true;
      this.status.textContent = this.dataset.loading;
      const image = new Image();
      image.src = this.dataset.sheet;
      try {
        await image.decode();
        this.sheet.style.backgroundImage = `url("${this.dataset.sheet}")`;
        this.sheet.hidden = false;
        this.poster.hidden = true;
        this.open.hidden = true;
        this.ready = true;
        this.stage.classList.add('is-ready');
        this.status.textContent = this.dataset.hint;
        this.draw(0);
      } catch (e) {
        this.status.textContent = this.dataset.error;
        this.open.disabled = false;
      }
      this.loading = false;
    }
    draw(frame) {
      this.frame = ((frame % 8) + 8) % 8;
      const [x,y,w,h] = this.meta.frames[this.frame];
      const box = Math.min(this.stage.clientWidth,this.stage.clientHeight)*.97;
      const scale = Math.min(box/w,box/h);
      Object.assign(this.sheet.style,{
        width: `${w*scale}px`, height: `${h*scale}px`,
        top: '50%', translate: '-50% -50%',
        backgroundSize: `${this.meta.width*scale}px ${this.meta.height*scale}px`,
        backgroundPosition: `${-x*scale}px ${-y*scale}px`, transform:'none'
      });
      this.stage.dataset.frame = String(this.frame);
    }
  });
})();
